import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.css']
})
export class InputDialogComponent implements OnInit {

  formControl: FormControl = new FormControl();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InputDialogComponentInput,
    private _dialogRef: MatDialogRef<InputDialogComponent>
  ) { }

  clear = () => this.formControl.setValue(null);
  close = () => this._dialogRef.close();
  confirm = () => this._dialogRef.close(this.formControl.value);

  ngOnInit(): void {
    this.setValidators();
  }

  setValidators(){
    let validators = [];
    if(typeof this.data.minLength === 'number') validators.push(Validators.minLength(this.data.minLength));
    if(validators.length > 0) this.formControl.setValidators(validators); 
  }

}

export class InputDialogComponentInput {
  minLength?: number;
  headline?: string;
  label?: string;
}
